import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";

import "antd/dist/antd.css";
import "./css/style.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";

// disable console.log in production environment
//if (process.env.REACT_APP_STAGE === "prod") console.log = () => {};

ReactGA.initialize("UA-233372313-1");

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
